@if (activeEnvironmentBanner; as banner) {
<div
  class="mile-env-banner w-100 text-center {{ banner.cssClass }}"
  role="status"
  aria-live="polite"
>
  {{ banner.text }}@if (banner.emphasizedPart) {
  <span class="mile-env-banner__pulse">{{ banner.emphasizedPart }}</span>
  }
</div>
}

<app-navbar></app-navbar>

<div class="d-flex w-100">
  <div class="sidebar-mobile d-md-none">
    @if(isSidebarOpen){
      <div class="overlay" (click)="toggleSidebar()"></div>
      <div class="menu p-3">
        <app-sidebar></app-sidebar>
      </div>
    }
  </div>

  <aside class="sidebar d-none d-md-flex flex-column">
    <div class="sidebar-container" 
         [ngClass]="{ 'open': !isSidebarCollapsed, 'pinned': isSidebarPinned }" 
         (mouseenter)="expandSidebar()"
         (mouseleave)="collapseSidebar()">
      
      <button class="btn-pin d-none d-md-block" (click)="togglePin()">
        <i class="fas" [ngClass]="isSidebarPinned ? 'fa-thumbtack text-primary' : 'fa-thumbtack'"></i>
      </button>

      <app-sidebar [collapsed]="isSidebarCollapsed"></app-sidebar>
    </div>
  </aside>

  <main class="content flex-grow-1 color-container"
        [ngClass]="{ 'sidebar-expanded': !isSidebarCollapsed }">
    
    <nav class="px-2 pt-2 d-md-none">
      <button class="btn btn-outline-primary" (click)="toggleSidebar()">
        <i class="fas fa-bars"></i>
      </button>
    </nav>

    <router-outlet></router-outlet>
  </main>
</div>